import { useServiceProps, dialogService, } from "ftl-dashboards-core";
import React from "react";
import FTLDialog from "../components/other/FTLDialog";
export default ({ style, service = dialogService }) => {
    const [props] = useServiceProps(service);
    return (React.createElement(FTLDialog, Object.assign({ style: style, onCancel: (e) => {
            (props === null || props === void 0 ? void 0 : props.onCancel) && props.onCancel(e);
            service.close();
        }, onClose: (...args) => {
            (props === null || props === void 0 ? void 0 : props.onClose) && props.onClose(...args);
            service.close();
        } }, props)));
};
//# sourceMappingURL=DialogContainer.js.map